import { render } from "./possess.vue?vue&type=template&id=2b063c86&scoped=true"
import script from "./possess.vue?vue&type=script&lang=js"
export * from "./possess.vue?vue&type=script&lang=js"

import "./possess.vue?vue&type=style&index=0&id=2b063c86&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b063c86"]])

export default __exports__